import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

import { AuthService } from './auth/auth.service';
import { AuthInterceptor } from './auth/auth-interceptor.service';


@NgModule({
  imports: [
    HttpClientModule
  ],
  providers: [
    AuthService,
    CookieService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  declarations: []
})
export class AuthModule { }
